import { latestCases } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

const tagStyles: Record<string, string> = {
  已澄清: 'bg-secondary-100 text-secondary-900',
  反转: 'bg-primary-100 text-primary-800',
  辟谣: 'bg-accent-100 text-accent-900',
  回应: 'bg-background-200 text-foreground-800',
  澄清: 'bg-secondary-100 text-secondary-900',
};

export default function LatestCasesSection() {
  return (
    <section
      id="latest"
      className="scroll-mt-24 border-y border-background-200 bg-background-100/60 py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          index="02"
          eyebrow="Latest Clarifications"
          title="最新澄清与辟谣合集"
          desc="标题给结论，摘要给依据。每条都标出日期与当前进展，方便你顺着时间往下核对。"
        />

        <div className="mt-12 flex flex-col">
          {latestCases.map((item, index) => (
            <article
              key={item.title}
              data-reveal
              style={{ transitionDelay: `${index * 60}ms` }}
              className="group grid grid-cols-1 gap-4 border-t border-background-200 py-7 transition-colors duration-200 md:grid-cols-12 md:gap-8 hover:border-primary-300"
            >
              <div className="flex items-center gap-3 md:col-span-2 md:flex-col md:items-start md:gap-3">
                <time className="font-heading text-lg font-bold text-foreground-950">
                  {item.date}
                </time>
                <span
                  className={`rounded-full px-2.5 py-1 font-label text-[11px] font-medium ${
                    tagStyles[item.tag] ?? 'bg-background-200 text-foreground-800'
                  }`}
                >
                  {item.tag}
                </span>
              </div>

              <div className="md:col-span-10">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 max-w-3xl text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                  {item.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-4">
                  <a
                    href="#timeline"
                    className="inline-flex items-center gap-1.5 whitespace-nowrap font-label text-xs text-primary-700 transition-colors duration-200 hover:text-primary-500"
                  >
                    <i className="ri-links-line" />
                    查看完整时间线
                  </a>
                  <span className="inline-flex items-center gap-1.5 font-label text-xs text-foreground-500">
                    <i className="ri-attachment-2" />
                    附原始材料
                  </span>
                </div>
              </div>
            </article>
          ))}
          <div className="border-t border-background-200" />

          <a
            data-reveal
            href="#collections"
            className="mt-8 inline-flex items-center gap-2 self-start whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 font-label text-sm text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
          >
            浏览全部澄清专题
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}